import { ActionType } from '@editor/src/js/constants/common-action-type';
import { PropertyEditorShowAction } from '@src/js/constant';
import { IMenuManager } from '@src/slide/application/service/menu-manager/menu-manager.interface';
import { IRightSideBarManager } from '@src/slide/application/service/right-side-bar-manager/right-side-bar-manager.interface';
import { UIModelType } from '@src/slide/domain/ui-model/element-modeles/constant';
import { IShapeModel } from '@src/slide/domain/ui-model/element-modeles/Interface/shape-model.interface';
import { FormService } from '@tencent/wb-ext-form';
import { InjectorService } from '@tencent/workbench';
import { FormLabelName, FormPanelName } from '@framework/workbench/drawer/constants';
import { getSelectedModelTypeArr } from '@framework/workbench/drawer/utils';
import i18n from '@i18next/i18n';
import { IRightSideBarService } from '../right-side-bar-service/core/interface';
import { ISelectionService } from '@src/slide/application/service/selection/selection-service.interface';
import { FillTypeFeature } from '@framework/workbench/drawer/ui/fill/fill-type/fill-type-feature';

export const NO_ACTION = 0;
// 样式tab 默认展开项
const STYLE_LABEL_OPEN_LIST = [FormLabelName.FILL, FormLabelName.BORDER, FormLabelName.CELL_SIZE];
// 字体tab 默认展开项
const FONT_LABEL_OPEN_LIST = [FormLabelName[ActionType.FONT], FormLabelName.PARAGRAPH, FormLabelName.TEXTBOX];
// 布局tab 默认展开项
const LAYOUT_LABEL_OPEN_LIST = [
    FormLabelName.ALIGN,
    FormLabelName.LEVEL,
    FormLabelName.SIZE,
    FormLabelName.ROTATE,
    FormLabelName.CELL_SIZE,
];
const TEXT_STYLE_LABEL_OPEN_LIST = [FormLabelName[ActionType.FONT_FILL], FormLabelName[ActionType.FONT_BORDER]];
// 文本/形状 默认展开项
const TEXT_LABEL_OPEN_LIST = [...STYLE_LABEL_OPEN_LIST, ...FONT_LABEL_OPEN_LIST, ...LAYOUT_LABEL_OPEN_LIST];
// 侧边栏默认展开列表
const DEFAUL_LABEL_OPEN_LIST = {
    [UIModelType.SHAPE]: [...TEXT_LABEL_OPEN_LIST, ...TEXT_STYLE_LABEL_OPEN_LIST],
    [UIModelType.GROUP]: [...TEXT_LABEL_OPEN_LIST, ...TEXT_STYLE_LABEL_OPEN_LIST],
    [UIModelType.IMAGE]: [...STYLE_LABEL_OPEN_LIST, FormLabelName.PICTURE_OPACITY, ...LAYOUT_LABEL_OPEN_LIST],
    [UIModelType.CONNECTOR]: [FormLabelName.BORDER, ...LAYOUT_LABEL_OPEN_LIST],
    [UIModelType.TABLE]: [...STYLE_LABEL_OPEN_LIST, ...FONT_LABEL_OPEN_LIST,
        FormLabelName.LEVEL, FormLabelName.SIZE, ...TEXT_STYLE_LABEL_OPEN_LIST],
    [UIModelType.EMPTY]: [
        FormLabelName.LAYOUT, FormLabelName.LAYOUT_CHANGE, FormLabelName.BACKGROUND, FormLabelName.SLIDE_SIZE,
        FormLabelName.FILL,
    ],
};
const DEFAUL_LABEL_CLOSE_LIST = {
    [UIModelType.TABLE]: [FormLabelName.ROTATE],
};
export const IMAGE_LABEL = i18n.t('图片');
export const STYLE_LABEL = i18n.t('填充与边框');
export const EFFECT_LABEL = i18n.t('效果');
export const TEXT_LABEL = i18n.t('文本框');
export const DEFAULT_INDEX = 0;
export const CHART_INDEX = 1;

/**
 * 管理侧边栏设置项状态
 */
export class FormSwitchManager {
    private formService: FormService;
    private fillFeature: FillTypeFeature;
    private selectionService: ISelectionService;
    private isDefaultSetting?: boolean;    // 是否是默认设置
    private operatedItems: string[] = []; // 记录用户操作过的设置项，避免默认打开该设置项
    private rightSideBarManager: IRightSideBarManager | undefined;
    private rightSideBarService: IRightSideBarService | undefined;
    private formLabel?: string;
    private formIndex?: number;
    private formName?: string;

    public constructor(
        rightSideBarManager: IRightSideBarManager | undefined,
        selectionService: ISelectionService,
        rightSideBarService: IRightSideBarService | undefined,
    ) {
        this.rightSideBarManager = rightSideBarManager;
        this.rightSideBarService = rightSideBarService;
        this.selectionService = selectionService;
        this.formService = InjectorService.get(FormService);
        this.fillFeature = InjectorService.get(FillTypeFeature);
    }

    /**
     * 双击打开侧边栏
     * @param showFormat
     * @param hasAction 双击打开的来源，比如从工具栏效果-更多设置打开
     */
    public toggleWithAction(showFormat: boolean, hasAction?: number): void {
        const EffectList = [
            { name: PropertyEditorShowAction.SHADOW_TOGGLE, label: FormLabelName[ActionType.SHADOW] },
            { name: PropertyEditorShowAction.REFLECTION_TOGGLE, label: FormLabelName[ActionType.REFLECTION] },
            { name: PropertyEditorShowAction.GLOW_TOGGLE, label: FormLabelName[ActionType.GLOW] },
            { name: PropertyEditorShowAction.SOFTEDGE_TOGGLE, label: FormLabelName[ActionType.SOFTEDGE] },
        ];
        const actionMap = {
            [PropertyEditorShowAction.EFFECT_TOGGLE]: () => {
                EffectList.forEach((item) => {
                    this.formService.setCollapsed(item.label, false);
                });
                this.changeFormToFormat(showFormat, FormPanelName.SHAPE, EFFECT_LABEL);
            },
            [PropertyEditorShowAction.TEXT_ADJUST_TOGGLE]: () => {
                FONT_LABEL_OPEN_LIST.forEach((label: string) => {
                    this.formService.setCollapsed(label, false);
                });
                this.changeFormToFormat(showFormat, FormPanelName.TEXT, TEXT_LABEL);
            },
            [PropertyEditorShowAction.IMAGE_TOGGLE]: () => {  // 设置图片格式打开侧边栏
                this.formService.setCollapsed(FormLabelName.PICTURE_OPACITY, false);
                this.changeFormToFormat(showFormat, FormPanelName.SHAPE, IMAGE_LABEL);
            },
            [PropertyEditorShowAction.SHAPE_TOOGLE]: () => {  // 设置形状格式打开侧边栏
                this.changeFormToFormat(showFormat, FormPanelName.SHAPE, STYLE_LABEL);
            },
            [PropertyEditorShowAction.FROM_IMAGE_FILL]: () => {
                this.setBgWithActionWithEditorShown();
                this.formService.setCollapsed(FormLabelName.FILL, false);
                this.changeFormToFormat(showFormat, FormPanelName.SHAPE, STYLE_LABEL);
            },
            [PropertyEditorShowAction.FROM_GRADUAL_FILL]: () => {
                this.setBgWithActionWithEditorShown();
                this.formService.setCollapsed(FormLabelName.FILL, false);
                this.changeFormToFormat(showFormat, FormPanelName.SHAPE, STYLE_LABEL);
            },
            [PropertyEditorShowAction.DOUBLE_CLICK_TOOGLE]: () => {
                this.changePropertyTabDoubleClick(showFormat);
            },
            [PropertyEditorShowAction.INSERT_FOOTER]: () => {
                this.formService.setCollapsed(FormLabelName.FOOTER, false);
                this.changeFormToFormat(showFormat, FormPanelName.SHAPE, STYLE_LABEL);
            },
            [PropertyEditorShowAction.CHART_TOGGLE]: () => {  // 设置图表格式打开侧边栏
                this.changeFormToFormat(showFormat, FormPanelName.SHAPE, undefined, CHART_INDEX);
            },
        };
        EffectList.forEach((effectItem) => {
            actionMap[effectItem.name] = () => {
                EffectList.forEach((item) => {
                    this.formService.setCollapsed(item.label, item.name !== effectItem.name);
                });
                this.changeFormToFormat(showFormat, FormPanelName.SHAPE, EFFECT_LABEL);
            };
        });
        typeof hasAction === 'number' && actionMap[hasAction]?.();
        if (showFormat) { // 侧边栏已打开的情况下，如果打开了RightSideBar，再次打开时需要关闭
            this.rightSideBarService?.hide();
        }
        this.rightSideBarManager?.setIsPropertyEditorShown(true);
        this.rightSideBarManager?.setPropertyEditorShowAction(NO_ACTION);
    }

    /**
     * 记录展开或者折叠过的设置项
     */
    public handleItemCollapsed = ({ label, collapsed }) => {
        if (this.isDefaultSetting) {
            this.isDefaultSetting = false;
            return;
        }
        let reportId: string;
        if (collapsed) {
            reportId = this.fillFeature.tdwDrawerConstMap.foldItem;
        } else {
            reportId = this.fillFeature.tdwDrawerConstMap.unfoldItem;
        }
        this.fillFeature.tdwDrawerReport(reportId, { ver5: label });
        // 记录操作过的item
        if (this.operatedItems.indexOf(label) === -1) {
            this.operatedItems.push(label);
        }
    };

    /**
     * 打开侧边栏后展开默认项
     */
    public handleLabelCollapse = (isSelectModelChange?: boolean) => {
        const selectedModelTypeArr = getSelectedModelTypeArr(this.selectionService.getSelectedModel());
        let defaultOpenList: string[] = [];
        let defaultCloseList: string[] = [];
        if (selectedModelTypeArr.length === 1) {
            defaultOpenList = DEFAUL_LABEL_OPEN_LIST[selectedModelTypeArr[0]];
            defaultCloseList = DEFAUL_LABEL_CLOSE_LIST[selectedModelTypeArr[0]];
        } else {
            defaultOpenList = [...STYLE_LABEL_OPEN_LIST, ...LAYOUT_LABEL_OPEN_LIST];
        }
        defaultOpenList?.forEach((item) => {
            if (this.operatedItems.indexOf(item) === -1) {
                this.isDefaultSetting = isSelectModelChange;
                // 在侧边栏打开的情况下执行该命令，会emit FormSectionCollapsed事件
                this.formService.setCollapsed(item, false);
            }
        });
        // 针对切换不同元素时，不同元素展开的差异项。因为侧边栏会默认记住打开和关闭的操作。
        defaultCloseList?.forEach((item) => {
            if (this.operatedItems.indexOf(item) === -1) {
                this.isDefaultSetting = isSelectModelChange;
                this.formService.setCollapsed(item, true);
            }
        });
    };

    /**
     * 切换侧边栏至“格式”
     */
    public changeFormToFormat = (showFormat: boolean, formName: string, label?: string, index?: number) => {
        if (showFormat) return;
        if (this.rightSideBarManager?.propertyEditorShowAction
            && !this.rightSideBarManager?.isPropertyEditorShown) {
            this.formName = formName;
            this.formLabel = label;
            this.formIndex = index;
            return;
        }
        let finalTabIndex = DEFAULT_INDEX;
        formName = this.formName ? this.formName : formName;
        this.formName = undefined;
        if (this.formIndex) {
            finalTabIndex = this.formIndex;
            this.formIndex = undefined;
            this.formLabel = undefined;
        } else if (this.formLabel) {
            const index = this.getLabelIndex(this.formLabel, formName);
            finalTabIndex = index;
            this.formLabel = undefined;
        }
        // 动画面板打开的情况下，需要切换到格式面板。changeForm函数会触发侧边栏刷新，避免做无用刷新
        this.formService.changeForm(formName, finalTabIndex);
    };

    /**
     * 获取指定label在schema中的索引
     */
    public getLabelIndex(label: string, form = FormPanelName.SHAPE) {
        // @ts-ignore
        return this.formService.getSchema()?.[form]?.tabs
            .findIndex(item => item.label === label);
    }

    // 判断是否需要直接设上背景
    private setBgWithActionWithEditorShown = () => {
        if (this.rightSideBarManager?.isPropertyEditorShown) {
            this.setBgWithAction();
        }
    };

    private setBgWithAction = () => {
        const action = this.rightSideBarManager?.propertyEditorShowAction;
        this.fillFeature.setBgWithAction(action);
        this.rightSideBarManager?.setPropertyEditorShowAction(NO_ACTION);
    };

    /**
     * 双击打开侧边栏时聚焦默认tab
     */
    private changePropertyTabDoubleClick = (showFormat: boolean) => {
        const selectedModel = this.selectionService.getSelectedModel();
        let formLabel: string | undefined = STYLE_LABEL;
        let formIndex;
        let formName = FormPanelName.SHAPE;
        if (selectedModel?.type === UIModelType.CHART) {
            formLabel = undefined;
            formIndex = CHART_INDEX;
        }
        if (selectedModel?.type === UIModelType.IMAGE) {
            formLabel = IMAGE_LABEL;
        }
        if (selectedModel?.type === UIModelType.SHAPE
                && (selectedModel as IShapeModel).isTextOrPlaceholder) {
            formName = FormPanelName.TEXT;
            formLabel = STYLE_LABEL;
        }
        this.changeFormToFormat(showFormat, formName, formLabel, formIndex);
    };
}
